/* Area24 blogartikel: inhoudsopgave, delen, cijfer geven bij Camo Corner. */
(() => {
  const art = document.querySelector('[data-a24-article]');
  if (!art || art.dataset.ready) return;
  art.dataset.ready = '1';

  /* ---------- inhoudsopgave (vanaf 3 tussenkoppen) ---------- */
  const prose = art.querySelector('[data-prose]');
  const toc = art.querySelector('[data-toc]');
  const heads = prose ? [...prose.querySelectorAll('h2')].filter((h) => h.textContent.trim()) : [];
  if (toc && heads.length >= 3) {
    const list = toc.querySelector('[data-toc-list]');
    const box = toc.querySelector('[data-toc-box]');
    const used = new Set();
    const links = heads.map((h) => {
      let id = h.id || h.textContent.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'kop';
      while (used.has(id) || (document.getElementById(id) && document.getElementById(id) !== h)) id += '-2';
      used.add(id);
      h.id = id;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${id}`;
      a.textContent = h.textContent.trim().replace(/\s+/g, ' ');
      li.append(a);
      list.append(li);
      return a;
    });
    toc.querySelector('[data-toc-count]').textContent = `(${heads.length})`;
    toc.hidden = false;

    // breed scherm: altijd open en meelopend; smal: dichtgeklapt boven de tekst
    const wide = window.matchMedia('(min-width: 1100px)');
    const setOpen = () => { box.open = wide.matches; };
    setOpen();
    wide.addEventListener('change', setOpen);
    list.addEventListener('click', (e) => { if (e.target.closest('a') && !wide.matches) box.open = false; });

    // huidige kop markeren
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          const i = heads.indexOf(en.target);
          links.forEach((l, j) => (j === i ? l.setAttribute('aria-current', 'true') : l.removeAttribute('aria-current')));
        });
      }, { rootMargin: '0px 0px -70% 0px' });
      heads.forEach((h) => io.observe(h));
    }
  }

  /* ---------- tabellen op smalle schermen zijwaarts scrollen ---------- */
  if (prose) prose.querySelectorAll('table').forEach((t) => {
    if (t.parentElement.classList.contains('a24b-table')) return;
    const w = document.createElement('div');
    w.className = 'a24b-table';
    w.tabIndex = 0;
    w.setAttribute('role', 'region');
    w.setAttribute('aria-label', 'Tabel');
    t.before(w);
    w.append(t);
  });

  /* ---------- delen ---------- */
  const share = art.querySelector('[data-share]');
  if (share) {
    const label = share.querySelector('[data-share-label]');
    const canShare = !!navigator.share;
    const canCopy = !!(navigator.clipboard && window.isSecureContext);
    if (canShare || canCopy) {
      share.hidden = false;
      if (!canShare) label.textContent = 'Kopieer link';
      share.addEventListener('click', async () => {
        const url = location.href.split('#')[0];
        if (canShare) {
          try { await navigator.share({ title: document.title, url }); } catch (e) { /* geannuleerd */ }
          return;
        }
        try {
          await navigator.clipboard.writeText(url);
          label.textContent = 'Link gekopieerd';
          setTimeout(() => { label.textContent = 'Kopieer link'; }, 2400);
        } catch (e) { /* niets */ }
      });
    }
  }

  /* ---------- cijfer geven ---------- */
  const form = art.querySelector('[data-a24-comment]');
  if (!form) return;
  const body = form.querySelector('[data-body]');
  const radios = [...form.querySelectorAll('input[name="a24score"]')];
  const syncRequired = () => {
    // met alleen een cijfer mag de tekst leeg blijven
    body.required = !radios.some((r) => r.checked);
  };
  radios.forEach((r) => r.addEventListener('change', syncRequired));

  art.querySelectorAll('[data-rate]').forEach((a) => a.addEventListener('click', () => {
    const r = radios.find((x) => x.value === a.dataset.rate);
    if (r) { r.checked = true; syncRequired(); }
    setTimeout(() => body.focus({ preventScroll: true }), 350);
  }));

  form.addEventListener('submit', () => {
    const r = radios.find((x) => x.checked);
    if (!r) return;
    const marker = `Mijn Tacticool-score: ${r.value}/10`;
    const txt = body.value.replace(/^Mijn Tacticool-score: \d+\/10\s*/i, '').trim();
    body.value = txt ? `${marker}\n\n${txt}` : marker;
  });
})();
